










































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import rdfUtils from '@/rdf/utils'

const MAX_VALUES = 5
const INITIAL_FACET_COUNT = 5

@Component
export default class FacetSidebar extends Vue {
  @Prop({ required: true })
  readonly filterData: any

  @Prop({ default: INITIAL_FACET_COUNT })
  readonly initialFacetCount: number

  @Prop({ default: false })
  readonly pendingChanges: boolean

  @Prop({ default: false })
  readonly hasAppliedFilters: boolean

  collapsedFacets: Record<string, boolean> = {}

  expandedFacets: Record<string, boolean> = {}

  facetsExpanded: boolean = false

  readonly maxValues = MAX_VALUES

  get hasActiveFilters(): boolean {
    return this.filterData.some((filter) => this.isFilterActive(filter))
  }

  get visibleFilterData() {
    return this.facetsExpanded
      ? this.filterData
      : this.filterData.slice(0, this.initialFacetCount)
  }

  toggleFacetsExpanded() {
    this.facetsExpanded = !this.facetsExpanded
  }

  isFilterActive(filter): boolean {
    return filter.values.some((value) => value.isChecked)
  }

  infoId(predicate): string {
    return `facet-info-${predicate}`
  }

  valueLabel(value): string {
    return value.label || rdfUtils.pathTerm(value.value) || value.value
  }

  isCollapsed(predicate): boolean {
    return !!this.collapsedFacets[predicate]
  }

  onToggle(predicate, event) {
    this.$set(this.collapsedFacets, predicate, !event.target.open)
  }

  isExpanded(predicate): boolean {
    return !!this.expandedFacets[predicate]
  }

  toggleExpand(predicate) {
    this.$set(this.expandedFacets, predicate, !this.isExpanded(predicate))
  }

  sortedValues(filter) {
    if (filter.sortByCount === false) {
      return filter.values
    }
    return [...filter.values].sort((a, b) => (b.count ?? 0) - (a.count ?? 0))
  }

  visibleValues(filter) {
    const values = this.sortedValues(filter)
    return this.isExpanded(filter.predicate)
      ? values
      : values.slice(0, MAX_VALUES)
  }
}
